import { formatMoney } from '@tcrd/shared';
import { cn } from './cn';

export function Money({ value, currency = 'DOP', className }: { value: string | null | undefined; currency?: string; className?: string }) {
  return <span className={cn('tabular-nums', className)}>{formatMoney(value, currency)}</span>;
}
